// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const UserAvatar = require('client-v2/common/components/user-avatar')
const { registerComponentEventHandlers } = require('client-v2/common/components/utils')
const { userProfileHref } = require('client-v2/common/models/user/actions')
// Entry component imports
const { UserFollowCapsuleButton } = require('client-v2/common/components/buttons')
// Entry container imports
const ProfileUserRecord = require('../profile-user/record')
const ProfileUserStatsRecord = require('../profile-user-stats/record')

const bem = BemEntity('UserProfileSocialHeader')

class UserProfileSocialHeader extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    registerComponentEventHandlers(this)
  }

  renderButtons() {
    if (this.props.isSelfProfile) {
      return null
    }
    return (
      tag('div', {
        className: bem.element('buttons')
      },
        tag(UserFollowCapsuleButton, {
          className: bem.element('follow-button'),
          checked: this.props.profileUser.isFollowing,
          onClick: this.onFollowClick
        })
      )
    )
  }

  renderUserDetails() {
    const { profileUser } = this.props
    return (
      tag('a', {
        className: bem.element('user-details-row'),
        href: userProfileHref(profileUser),
        onClick: this.onUserDetailsClick
      },
        tag('div', {
          className: bem.element('user-details-column')
        },
          this.renderUserPhoto()
        ),
        tag('div', {
          className: bem.element('user-details-column')
        },
          this.renderUserShortName(),
          this.renderUserFullName()
        )
      )
    )
  }

  renderUserFullName() {
    const fullName = this.props.profileUser['display_name']
    return (
      tag('div', {
        className: bem.element('user-full-name'),
        title: fullName
      },
        fullName
      )
    )
  }

  renderUserPhoto() {
    return tag(UserAvatar, {
      className: bem.element('user-photo'),
      user: this.props.profileUser,
      visible: true
    })
  }

  renderUserShortName() {
    const shortName = `@${this.props.profileUser.username}`
    return (
      tag('div', {
        className: bem.element('user-short-name'),
        title: shortName
      },
        shortName
      )
    )
  }

  // Root render method

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        this.renderUserDetails(),
        this.renderButtons()
      )
    )
  }

}

UserProfileSocialHeader.propTypes = {
  // Flags
  isLoggedIn: PropTypes.bool,
  isSelfProfile: PropTypes.bool,
  // Values
  profileUser: PropTypes.shape(ProfileUserRecord.propTypes).isRequired,
  profileUserStats: PropTypes.shape(ProfileUserStatsRecord.propTypes).isRequired
}

// Callbacks
UserProfileSocialHeader.eventHandlerKeys = [
  'onFollowClick',
  'onUserDetailsClick'
]
UserProfileSocialHeader.eventHandlerKeys.forEach(key => {
  UserProfileSocialHeader.propTypes[key] = PropTypes.func
})

module.exports = UserProfileSocialHeader
